// extracted by mini-css-extract-plugin
module.exports = {"account-modal":"czZKw","form-wrapper":"_3gyI0","tabs":"FVCiJ","tab-item":"AgvDP","active":"itcPt","info":"xBCCq","info-header":"_2KiZ4","info-text":"_1fdPu","info-image":"ZwTW3"};